import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

export const PROJECTDIGEST_VERIFICATION_STATUS = {
  CANNOT_VERIFY: -1,
  PENDING: 0,
  VERIFIED: 1,
}

export const PROJECTDIGEST_VERIFICATION_METHODS = {
  REFERRAL: 'referral',
  IMDB: 'imdb',
  TIMESTAMP: 'timestamp',
  BYLINE_CREDIT: 'attribution',
}

export const PROJECTDIGEST_VERIFICATION_METHODS_REQUIRES_ADDITIONAL_INFO = new Set([
  PROJECTDIGEST_VERIFICATION_METHODS.REFERRAL,
  PROJECTDIGEST_VERIFICATION_METHODS.IMDB,
  PROJECTDIGEST_VERIFICATION_METHODS.TIMESTAMP,
]);

export const METHOD_NAME_MAP = {
  [PROJECTDIGEST_VERIFICATION_METHODS.REFERRAL]: 'Client contact',
  [PROJECTDIGEST_VERIFICATION_METHODS.IMDB]: 'IMDB link',
  [PROJECTDIGEST_VERIFICATION_METHODS.TIMESTAMP]: 'Timestamp',
  [PROJECTDIGEST_VERIFICATION_METHODS.BYLINE_CREDIT]: 'Attribution',
}

  /*
  *   The list of service ids where an attribution verification type is applicable.
  *   MUST BE KEPT IN SYNC WITH `VALID_ATTRIBUTION_SERVICE_IDS` ON BACKEND
  *   IN `/Models/ProjectdigestVerification.php`
  */
export const VALID_ATTRIBUTION_SERVICE_IDS = [
  '26',
  '34',
  '113',
  '114',
  '115',
  '116',
  '117',
  '118',
  '119',
];

class ProjectdigestVerification extends ShModel {
  @attr('number') status;
  @attr('string') method;
  @attr('string') supportingValue;
  @attr('string') referralFirstname;
  @attr('string') referralLastname;
  @attr('string') referralEmail;
  @attr('string') referralCompany;
  @attr('date') createdAt;
  @attr('date') updatedAt;

  @belongsTo('projectdigest', { async: false }) projectdigest;

  get methodFullName() {
    return METHOD_NAME_MAP[this.method] ?? 'Unknown';
  }
}

export default ProjectdigestVerification;
